export enum ActivationUserDocumentType {
  DOCUMENTO_ATIVACAO = 'DOCUMENTO_ATIVACAO',
  DOCUMENTO_ATIVACAO_ROSTO = 'DOCUMENTO_ATIVACAO_ROSTO',
}
